import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ChecksList  {
    _originalTypeClassName = "zERP.BO.ChecksList";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ChecksList.translate = translateService;
}
this.Checks = [];
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.CreatedAt = null;
this.Description = null;
this.NumberOfChecks = null;
this.IsPaid = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CreatedAt:any;
Description:any;
NumberOfChecks:any;
IsPaid:any;
Checks:any;
CurrentChecksStatus:any;
Entity:any;
static setChecks = ($this, items) => {
                if (items == null) items = [];
                if ($this.Checks == null) $this.Checks = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Checks.length > 0) {
                    Domain.ChecksList.removeChecks($this, $this.Checks[0]);
                }

                Domain.ChecksList.addManyChecks($this, copyItems);
            }
static addManyChecks = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ChecksList.addChecks($this, items[i]);
                }
            }
static addChecks = ($this, item) => {
                if ($this.Checks == null) $this.Checks = [];
                if (item == null || $this.Checks.indexOf(item) > -1) return;
                $this.Checks.push(item);
if (item.ChecksList != $this) {
Domain.Check.setChecksList(item, $this);
}
}
static addRangeChecks = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ChecksList.addChecks($this, item));
            }
static removeChecks = ($this, item) => {
                if ($this == null || $this.Checks == null || $this.Checks.indexOf(item) === -1) return;
                var _index = $this.Checks.indexOf(item);
                $this.Checks.splice(_index, 1);
item.ChecksList = null;
}
static clearChecks = ($this) => { $this.Checks = null; }
static setCurrentChecksStatus = ($this, value) => {
var oldValue = $this.CurrentChecksStatus;
$this.CurrentChecksStatus = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}